import './AssessmentFlow.css';

export default function YesNoInput({ value, onChange }) {
    return (
        <div className="yesno-input">
            <button
                type="button"
                className={`yesno-btn ${value === false ? 'selected' : ''}`}
                onClick={() => onChange(false)}
            >
                No
            </button>
            <button
                type="button"
                className={`yesno-btn ${value === true ? 'selected' : ''}`}
                onClick={() => onChange(true)}
            >
                Yes
            </button>
        </div>
    );
}
